module.exports = __webpack_public_path__ + "static/media/Delivery.8baca0be.svg";